import {
    formatData,
    getGaClientId,
    GA_PROMOTION_CLICK_KEY,
    GA_PROMOTION_VIEW_KEY,
    GA_ECOMMERCE_CATEGORY
} from '@common/Tracking';
import { getVisitorDataCookieAsObject } from '@helpers/visitor';

const PLATFORMS = {
    ga: 'ga',
    ga4: 'ga4',
    native: 'mobile-native'
};

const formatPromotionData = (promotionData, platform) => {
    const {
        trackingId,
        trackingCreative,
        trackingPosition,
        trackingName
    } = promotionData;

    const topPage = !App.Config.navGender ? 'Main_Entrypage' : (App.Config.navGender).toUpperCase();
    const name = !trackingName ? topPage : trackingName;

    if (platform === PLATFORMS.ga4) {
        return {
            creative_name: trackingCreative,
            creative_slot: trackingPosition,
            promotion_name: name,
            promotion_id: trackingId
        };
    }

    if (platform === PLATFORMS.native) {
        return {
            item_name: name,
            creative_name: trackingCreative,
            creative_slot: trackingPosition,
            item_id: trackingId
        };
    }

    return {
        id: trackingId,
        name,
        creative: trackingCreative,
        position: trackingPosition
    };
};

const createPromotionsArray = (promotionData, platform) => {
    const promotions = [];

    if (Array.isArray(promotionData)) {
        promotionData.forEach((promotion) => {
            promotions.push(formatPromotionData(promotion, platform));
        });
    } else {
        promotions.push(formatPromotionData(promotionData, platform));
    }

    return promotions;
};

export const assemblePromotionData = (action, promotionData, setupEcommPromotions = null) => {
    const {
        page_path: pagePath,
        page_type: pageType
    } = App.Config.GaTrackingPage;

    const promotions = setupEcommPromotions || createPromotionsArray(promotionData);
    const ecommKey = action === 'click' ? GA_PROMOTION_CLICK_KEY : GA_PROMOTION_VIEW_KEY;
    const eventData = {
        page_path: pagePath,
        page_type: pageType,
        ...formatData(getVisitorDataCookieAsObject()),
        ...App.Config.GaTrackingData,
        client_id: getGaClientId(),
        ecommerce: {
            [ecommKey]: {
                promotions
            }
        }
    };

    const eventInfoLabel = action === 'click' && promotions.length > 0 ? promotions[0].id : '';

    const eventInfo = {
        category: GA_ECOMMERCE_CATEGORY,
        action: `promotion ${action}`,
        label: eventInfoLabel,
        value: null,
        non_interaction: 1
    };

    return {
        eventData,
        eventInfo
    };
};

export const assemblePromoDataForApp = (data) => {
    const promotions = createPromotionsArray(data, PLATFORMS.native);

    const itemId = Array.isArray(data) ? 'non.discount' : data.trackingId;

    return {
        is_promotions: 'true',
        content_type: 'internal promotions',
        item_id: itemId,
        promotions,
        webview_path: window?.location?.href ?? null
    };
};

export const assembleGA4PromotionData = (action, promotionData) => {
    const promotions = createPromotionsArray(promotionData, PLATFORMS.ga4);

    return {
        items: promotions
    };
};
